import { Navigate, Outlet, useLocation } from "react-router-dom";
import { ALUMNI_ROOT, isAlumniPath, useShellAccess } from "@/lib/adminPilot";

/**
 * Sends each person to the shell that is theirs: coordinators to the alumni console, everyone
 * else to the admin portal. A platform ADMIN in the pilot org may be in either, and switches
 * between them from the sidebar (`ShellSwitch`).
 *
 * Sits inside `RequireAuth`, which has already waited for `currentUser`, so the answer is in the
 * cache by the time this renders and there is no flash of the wrong shell.
 */
export function AdminPilotGate() {
    const access = useShellAccess();
    const { pathname } = useLocation();
    const inAlumni = isAlumniPath(pathname);

    if (access === "alumni" && !inAlumni) {
        return <Navigate to={ALUMNI_ROOT} replace />;
    }
    if (access === "portal" && inAlumni) {
        return <Navigate to="/" replace />;
    }
    return <Outlet />;
}
